import React from 'react';

import {Collections, Objects} from "components";
import Framework from "@beardeddevops/react.framework";
import APPCONFIG from "constants/Config";

import {Button} from "reactstrap";
const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/dashboard',
		icon: 'dashboard',
	},
	{
		name: 'Work Orders',
		url: '/work-orders',
		icon: 'wrench',
	}
];

export default class WorkOrders extends Framework.Components.View {

	render() {
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
						<Button data-id="add-work-order" onClick={this.toggle('modalWorkOrder')} size={"sm"} className="primary-button">
							<i className="fa fa-wrench"/>&nbsp;&nbsp;Start Work Order
						</Button>
				</Framework.Components.PageBar>


				<Collections.WorkOrders
					history={this.props.history}
					reloadParent={this.props.reloadParent}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>

				<Framework.Elements.UniversalModal
					locations={this.props.locations}
					name={"Work Order"}
					title={'Start Work Order'}
					submitLabel={'Start Work Order'}
					object={Objects.AddWorkOrder}
					history={this.props.history}
					toggle={this.state['modalWorkOrder']}
					reportClose={this.reportClose('modalWorkOrder')}
					afterSave={this.handleAfterSave}
					size={'xl'}
					project={'pos'}
				/>

			</div>
		);
	}
}
